import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { formatPrice } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { lang, t } = useLang();
  const name = product.name?.[lang] || product.name?.en;
  const tagline = product.tagline?.[lang] || product.tagline?.en;

  return (
    <Link
      to={`/shop/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block"
    >
      <div className="relative bg-maly-creamDeep aspect-[3/4] overflow-hidden img-zoom">
        <img
          src={product.images?.[0]}
          alt={name}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        {product.new && (
          <div className="absolute top-4 left-4 font-body text-[10px] tracking-[0.3em] uppercase bg-maly-cream/95 backdrop-blur-sm text-maly-navy px-3 py-1.5">
            {t.common.newIn}
          </div>
        )}
        {/* Color swatches overlay */}
        {product.colors?.length > 0 && (
          <div className="absolute bottom-4 left-4 flex gap-1.5 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
            {product.colors.slice(0, 4).map((c) => (
              <span
                key={c.value}
                className="w-3.5 h-3.5 rounded-full border border-white/80 shadow-sm"
                style={{ background: c.hex }}
                title={c.label}
              />
            ))}
          </div>
        )}
      </div>
      <div className="pt-5 pb-2 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-display text-lg lg:text-xl leading-tight">{name}</h3>
          {tagline && (
            <p className="font-body text-xs opacity-60 mt-1 leading-relaxed">{tagline}</p>
          )}
        </div>
        <div className="font-body text-sm font-medium whitespace-nowrap">
          {formatPrice(product.price, product.currency)}
        </div>
      </div>
    </Link>
  );
}
